export default "__VITE_ASSET__BD4RvgFh__"